"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSceneLocationsToLoads = exports.mapScenes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Utils_1 = require("../../../Utils");
const indexSceneLocationsToSceneLocationUI = (switchesWithLocations, switchesToLoadMapping) => {
    let locations = [];
    for (const switchWithLocation of switchesWithLocations) {
        locations = lodash_1.default.compact([...locations, ...Object.keys(switchWithLocation.model.actions).map((action) => {
                const button = Number.parseInt(action.slice(6), 10) - 1;
                const targetedLoadMap = switchesToLoadMapping.find((map) => map.switch.includes(switchWithLocation.id));
                if (targetedLoadMap) {
                    return ({
                        button,
                        loadUUID: (0, Utils_1.convertIdToUUID)(targetedLoadMap.load),
                        sceneUUID: (0, Utils_1.convertIdToUUID)(switchWithLocation.model.actions[action]),
                    });
                }
                return undefined;
            })]);
    }
    return locations;
};
const mapScenes = (sceneActuators, sceneDevices, loadDevices, switchDevices, allDevices) => {
    const switchesMappedToLoads = lodash_1.default.compact(switchDevices.map((switchDevice) => {
        const theOneLoad = loadDevices.find((loadDevice) => loadDevice.mesh.uniqueId === switchDevice.mesh.uniqueId);
        if (theOneLoad) {
            return {
                switch: switchDevice.id,
                load: theOneLoad.id,
            };
        }
        return undefined;
    }));
    const sceneButtonLocations = indexSceneLocationsToSceneLocationUI(allDevices.filter((d) => {
        const { model } = d;
        return model && !lodash_1.default.isEmpty(model.actions);
    }), switchesMappedToLoads);
    const convertedScenes = [];
    for (const sceneActuator of sceneActuators) {
        const sceneLocations = sceneButtonLocations.filter((loc) => sceneActuator.id.includes(loc.sceneUUID));
        const sceneDevice = sceneDevices.find((device) => device.id === sceneActuator.deviceId);
        const indexLocations = [];
        for (const loc of sceneLocations) {
            const targetedLoadMap = switchesMappedToLoads.find((map) => map.load.includes(loc.loadUUID));
            if (targetedLoadMap) {
                indexLocations.push({
                    target: targetedLoadMap.load,
                    button: loc.button,
                });
            }
        }
        if (sceneDevice) {
            convertedScenes.push(Object.assign(Object.assign({}, sceneActuator), { name: sceneDevice.name, model: sceneDevice.model, activationLyteByte: sceneDevice.activationLyteByte, locations: indexLocations, sceneMeshId: sceneDevice.mesh.uniqueId }));
        }
    }
    return convertedScenes;
};
exports.mapScenes = mapScenes;
const addSceneLocationsToLoads = (loads, switches) => {
    var _a;
    const loadsWithSceneLocations = [];
    for (const load of loads) {
        const mainSwitch = switches.find((s) => s.id === load.primary_device_id);
        if (mainSwitch !== undefined) {
            loadsWithSceneLocations.push(Object.assign(Object.assign({}, load), { sceneLocations: Object.assign({}, (_a = mainSwitch.model) === null || _a === void 0 ? void 0 : _a.actions) }));
        }
        else {
            loadsWithSceneLocations.push(load);
        }
    }
    return loadsWithSceneLocations;
};
exports.addSceneLocationsToLoads = addSceneLocationsToLoads;
//# sourceMappingURL=Scenes.js.map